import { Component, inject, Input } from '@angular/core';
import { getFormattedYearMonthDate } from '../../../shared/util/date-helper';
import { QueryParamService } from '../../../shared/util/query-params.service';
import {
  ConstructionDocumentItem,
  ConstructionDocumentsResponse,
} from '../../entities/construction-documents-entities';
import { ConstructionDocumentsService } from '../../service/construction-documents.service';
import {
  handleOnClickConstructionDocumentsItem,
  handleOpenFolder,
} from '../folder-content-helper';

@Component({
  selector: 'app-folder-content-mobile',
  templateUrl: './folder-content-mobile.component.html',
  styleUrl: './folder-content-mobile.component.scss',
  standalone: false,
})
export class FolderContentMobileComponent {
  private readonly constructionDocumentsService = inject(
    ConstructionDocumentsService,
  );

  @Input() folderContent: ConstructionDocumentsResponse;

  constructor(private readonly queryParamService: QueryParamService) {}

  formatDate(date: string) {
    return getFormattedYearMonthDate(date);
  }

  handleOnClickIcon(item: ConstructionDocumentItem) {
    handleOnClickConstructionDocumentsItem(
      item,
      this.queryParamService,
      this.constructionDocumentsService,
    );
  }

  handleOnClickRow(item: ConstructionDocumentItem) {
    if (item.type === 'FOLDER') {
      handleOpenFolder(item, this.queryParamService);
    }
  }
}
